// import { useEffect, useState } from "react";
// import { useMap } from "react-leaflet";
// import L from "leaflet";
// import { selectLayerDataSet } from "../../../features/layers/overlaylayerslice";
// import { useSelector } from "react-redux";

// const VelocityLayer = () => {
//   const map = useMap();
//   const overlayLayers = useSelector(selectLayerDataSet);
//   const [mainData, setMainData] = useState(null);
//   const [velocityLayer, setVelocityLayer] = useState(null); // State to store the velocity layer instance

//   useEffect(() => {
//     const datas = (data) => {
//       if (data.text==='Global Model' && data.class === 'Model') {
//         setMainData(data);
//         console.log(data);
//       }
//     };
//     if (Array.isArray(overlayLayers)) {
//       overlayLayers.forEach((overlayer) => datas(overlayer));
//     }
//   }, [overlayLayers]);

//   useEffect(() => {
//     if (!map || !mainData) return;
//     if (velocityLayer) {
//       map.removeLayer(velocityLayer);
//       setVelocityLayer(null); 
//     }

//     const center = map.getCenter();
//     const lat = center.lat;
//     const lng = center.lng;

//     console.log(mainData);
//     let url;
//     if (mainData.text === 'Global Model' && mainData.showWindVectors) {
//       url = `https://api.ncmrwf.gov.in/windVectors?date=${mainData.date}&pressure=${mainData.altitude}&lat=${lat}&lon=${lng}&hour=${mainData.hours}`;
//     }

//     fetch(url)
//       .then((response) => {
//         if (!response.ok) {
//           throw new Error("Failed to fetch wind data");
//         }
//         return response.json();
//       })
//       .then((windData) => {
//         console.log("Wind data loaded", windData);

//         const newVelocityLayer = L.velocityLayer({
//           displayValues: true,
//           displayOptions: {
//             velocityType: 'Wind',
//             position: 'bottomleft',
//             emptyString: 'No wind data',
//             showCardinal: true,
//           },
//           data: windData,
//           minVelocity: 10,
// 		      maxVelocity: 90,
// 		      velocityScale: 0.02,
// 		      colorScale: ["#00FF00","#33ff00","#66ff00","#99ff00","#ccff00","#FFFF00","#FFCC00","#ff9900","#ff6600","#FF3300","#ff0000"],
//           zIndex: 100,
//         });
//         newVelocityLayer.addTo(map);
//         setVelocityLayer(newVelocityLayer);
//       })
//       .catch((error) => {
//         console.error("Error loading wind data:", error);
//       });
//   }, [map, mainData]);

//   return null;
// };

// export default VelocityLayer;

// import { useEffect, useState } from "react";
// import { useMap } from "react-leaflet";
// import L from "leaflet";
// import { selectLayerDataSet } from "../../../features/layers/overlaylayerslice";
// import { useSelector } from "react-redux";

// const VelocityLayer = () => {
//   const map = useMap();
//   const overlayLayers = useSelector(selectLayerDataSet);
//   const [mainData, setMainData] = useState(null);
//   const [velocityLayer, setVelocityLayer] = useState(null);

//   useEffect(() => {
//     const selectedData = overlayLayers.find(
//       (data) => data.text === "Global Model" && data.class === "Model"
//     );
//     setMainData(selectedData || null);
//   }, [overlayLayers]);

//   useEffect(() => {
//     if (!map || !mainData) return;

//     if (!mainData.showWindVectors) {
//       if (velocityLayer) {
//         map.removeLayer(velocityLayer);
//         setVelocityLayer(null);
//       }
//       return;
//     }

//     if (velocityLayer) return; // Prevent duplicate layers

//     const center = map.getCenter();
//     const lat = center.lat;
//     const lng = center.lng;

//     const url = `https://api.ncmrwf.gov.in/windVectors?date=${mainData.date}&pressure=${mainData.altitude}&lat=${lat}&lon=${lng}&hour=${mainData.hours}`;

//     fetch(url)
//       .then((response) => {
//         if (!response.ok) {
//           throw new Error("Failed to fetch wind data");
//         }
//         return response.json();
//       })
//       .then((windData) => {
//         console.log("Wind data loaded", windData);

//         const newVelocityLayer = L.velocityLayer({
//           displayValues: true,
//           displayOptions: {
//             velocityType: "Wind",
//             position: "bottomleft",
//             emptyString: "No wind data",
//             showCardinal: true,
//           },
          
//           data: windData,
//           minVelocity: 6,
// 		      maxVelocity: 50,
// 		      velocityScale: 0.02,
// 		      //colorScale: ["#20B2AA","#2E8B57","#32CD32","#ADFF2F","#9ACD32","#FFFF00","#FFA500","#FF6347","#FF0000","#DC143C","#800000"],
//           // minVelocity: 10,
//           // maxVelocity: 90,
//           // velocityScale: 0.02,
//           colorScale: [
//             "#00FF00",
//             "#33ff00",
//             "#66ff00",
//             "#99ff00",
//             "#ccff00",
//             "#FFFF00",
//             "#FFCC00",
//             "#ff9900",
//             "#ff6600",
//             "#FF3300",
//             "#ff0000",
//           ],
//           zIndex: 100,
//         });

//         newVelocityLayer.addTo(map);
//         setVelocityLayer(newVelocityLayer);
//       })
//       .catch((error) => {
//         console.error("Error loading wind data:", error);
//       });
//   }, [map, mainData, velocityLayer]);

//   return null;
// };

// export default VelocityLayer;


// import { useEffect, useState } from "react";
// import { useMap } from "react-leaflet";
// import L from "leaflet";
// import { selectLayerDataSet } from "../../../features/layers/overlaylayerslice";
// import { useSelector } from "react-redux";

// const VelocityLayer = () => {
//   const map = useMap();
//   const overlayLayers = useSelector(selectLayerDataSet);
//   const [mainData, setMainData] = useState(null);
//   const [velocityLayer, setVelocityLayer] = useState(null);

//   useEffect(() => {
//     const selectedData = overlayLayers.find(
//       (data) => data.text === "Global Model" && data.class === "Model"
//     );
//     setMainData(selectedData || null);
//   }, [overlayLayers]);

//   useEffect(() => {
//     if (!map || !mainData || !mainData.showWindVectors) {
//       if (velocityLayer) {
//         map.removeLayer(velocityLayer);
//         setVelocityLayer(null);
//       }
//       return;
//     }

//     if (velocityLayer) {
//       map.removeLayer(velocityLayer);
//       setVelocityLayer(null);
//     }

//     const center = map.getCenter();
//     const lat = center.lat;
//     const lng = center.lng;

//     const url = `https://api.ncmrwf.gov.in/windVectors?date=${mainData.date}&pressure=${mainData.altitude}&lat=${lat}&lon=${lng}&hour=${mainData.hours}`;

//     fetch(url)
//       .then((response) => {
//         if (!response.ok) {
//           throw new Error("Failed to fetch wind data");
//         }
//         return response.json();
//       })
//       .then((windData) => {
//         console.log("Wind data loaded", windData);

//         const newVelocityLayer = L.velocityLayer({
//           displayValues: true,
//           displayOptions: {
//             velocityType: "Wind",
//             position: "bottomleft",
//             emptyString: "No wind data",
//             showCardinal: true,
//           },
//           data: windData,
//           minVelocity: 6,
//           maxVelocity: 50,
//           velocityScale: 0.02,
//           colorScale: [
//             "#00FF00",
//             "#33ff00",
//             "#66ff00",
//             "#99ff00",
//             "#ccff00",
//             "#FFFF00",
//             "#FFCC00",
//             "#ff9900",
//             "#ff6600",
//             "#FF3300",
//             "#ff0000",
//           ],
//           zIndex: 100,
//         });

//         newVelocityLayer.addTo(map);
//         setVelocityLayer(newVelocityLayer);
//       })
//       .catch((error) => {
//         console.error("Error loading wind data:", error);
//       });

//     return () => {
//       if (velocityLayer) {
//         map.removeLayer(velocityLayer);
//       }
//     };
//   }, [map, mainData?.date, mainData?.altitude, mainData?.showWindVectors]);

//   return null;
// };

// export default VelocityLayer;


import { useEffect, useState } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import { selectLayerDataSet } from "../../../features/layers/overlaylayerslice";
import { useSelector } from "react-redux";

const VelocityLayer = () => {
  const map = useMap();
  const overlayLayers = useSelector(selectLayerDataSet);
  const [mainData, setMainData] = useState(null);
  const [velocityLayer, setVelocityLayer] = useState(null);

  useEffect(() => {
    const selectedData = overlayLayers.find(
      (data) => data.text === "Mithuna GLB" && data.class === "Model"
    );
    setMainData(selectedData || null);
  }, [overlayLayers]);

  useEffect(() => {
    if (!map || !mainData || !mainData.showWindVectors) {
      // Remove the previous velocity layer if it exists
      if (velocityLayer) {
        map.removeLayer(velocityLayer);
        setVelocityLayer(null);
      }
      return;
    }

    // Clean up the previous layer if it exists
    if (velocityLayer) {
      map.removeLayer(velocityLayer);
      setVelocityLayer(null);
    }

    const center = map.getCenter();
    const lat = center.lat;
    const lng = center.lng;

    const url = `https://api.ncmrwf.gov.in/windVectors?date=${mainData.date}&odate=${mainData.odate}&pressure=${mainData.altitude}&lat=${lat}&lon=${lng}&hour=${mainData.hours}`;
    // const url =`https://nwp.ncmrwf.gov.in/dashboard/wind/${mainData.altitude}/${mainData.altitude}_uvwind_${mainData.date}.json`
    // const url=`https://nwp.ncmrwf.gov.in/dashboard/wind/925/uv_wind_925_uvwind_2025-04-03-hr-00-00-00.json`
    // To handle multiple requests properly, add a cleanup function that will only use the latest response
    let isCancelled = false;

    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch wind data");
        }
        return response.json();
      })
      .then((windData) => {
        if (isCancelled) return; // If the component is unmounted or a new request was made, skip this result

        console.log("Wind data loaded", windData);

        const newVelocityLayer = L.velocityLayer({
          displayValues: true,
          displayOptions: {
            velocityType: "Wind",
            position: "bottomleft",
            emptyString: "No wind data",
            showCardinal: true,
          },
          data: windData,
          // minVelocity: 6,
          // maxVelocity: 50,
          // velocityScale: 0.02,
          minVelocity: 2,
          maxVelocity: 30,
          velocityScale: 0.005,
          colorScale: [
            "#00FF00",
            "#33ff00",
            "#66ff00",
            "#99ff00",
            "#ccff00",
            "#FFFF00",
            "#FFCC00",
            "#ff9900",
            "#ff6600",
            "#FF3300",
            "#ff0000",
          ],
          zIndex: 100,
        });

        newVelocityLayer.addTo(map);
        setVelocityLayer(newVelocityLayer);
      })
      .catch((error) => {
        console.error("Error loading wind data:", error);
      });

    // Cleanup function to set isCancelled to true when the effect is cleaned up or new data is loaded
    return () => {
      isCancelled = true;
      if (velocityLayer) {
        map.removeLayer(velocityLayer);
      }
    };
  }, [map, mainData?.date, mainData?.altitude, mainData?.showWindVectors]);

  return null;
};

export default VelocityLayer;
